import { render, staticRenderFns } from "./RoutesList.vue?vue&type=template&id=aef2f55a&"
import script from "./RoutesList.vue?vue&type=script&lang=js&"
export * from "./RoutesList.vue?vue&type=script&lang=js&"
import style0 from "./RoutesList.vue?vue&type=style&index=0&id=aef2f55a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports